import styles from './ModalConfirmRegister.module.css';

import Modal from 'react-responsive-modal';
import confirmRegister from '../../../../assets/images/confirmRegister.png';
import { Button } from '../../../../components/Button';

interface IModalConfirmRegister {
  modalIsOpen: boolean;
  toggleModal: () => void;
}
export function ModalConfirmRegister({
  modalIsOpen,
  toggleModal,
}: IModalConfirmRegister) {
  return (
    <Modal open={modalIsOpen} onClose={toggleModal} center>
      <div className="contents-modal">
        <div className="d-flex justify-content-center">
          <img className={styles.alert} src={confirmRegister} alt="" />
        </div>
        <h1 className="title-modal">Falta pouco!</h1>
        <p className="subtitle-modal">
          Complete mais algumas informações e nos ajude a oferecer a você uma
          experiência espetacular!
        </p>
      </div>
      <div className={styles.contentBtn}>
        <Button
          isModal
          text="Vamos lá"
          type="button"
          color="primary"
          onClick={toggleModal}
        />
      </div>
    </Modal>
  );
}
